import React, { useState, useEffect } from 'react'
import { createMessage } from '../../../api/Messagerie'
import { createNotifications } from '../../../api/Notifications'

type Message = {
  chatId: string
  content: string
  createdAt: Date
  id: string
  updatedAt: Date
  userEmail: string
}

interface ChatFooterProps {
  socket: any
  chatId: string | undefined
  token: string
  authState: {
    email: string
    firstname: string
    lastname: string
    phoneNumber: string
    createdAt: Date
    updatedAt: Date
    userImg: string
    birthdate: string
    city: string
    isVisiteur: boolean
  }
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>
  otherUserEmail: string | undefined
}

const ChatFooter: React.FC<ChatFooterProps> = ({
  socket,
  chatId,
  setMessages,
  token,
  authState,
  otherUserEmail,
}) => {
  const [messageTemp, setMessageTemp] = useState<string>('')
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const [typingTimer, setTypingTimer] = useState<NodeJS.Timeout | null>(null)

  const handleTyping = () => {
    // Clear the existing typing timer if it exists
    if (typingTimer) {
      clearTimeout(typingTimer)
    }

    // Set a new typing timer with a delay of, for example, 1000 milliseconds (1 second)
    const newTypingTimer = setTimeout(() => {
      // Vous pouvez émettre un événement 'stopped typing' ici si nécessaire.
    }, 1000)

    setTypingTimer(newTypingTimer)
  }

  const handleSendMessage = async () => {
    if (chatId && token) {
      try {
        const response = await createMessage(token, chatId, messageTemp)
        const persistedMessage: Message | undefined = response?.message

        if (persistedMessage) {
          setMessages((prevMessages) => [...prevMessages, persistedMessage])

          // Notif temps réel: l'autre utilisateur voit le message sans rechargement
          socket.emit('message', {
            ...persistedMessage,
            socketID: socket.id,
          })
        }
      } catch (error) {
        console.error('Erreur lors de la création du message :', error)
      }
    }

    if (messageTemp.trim()) {
      if (authState.firstname) {
        const data = {
          type: 'message',
          content: messageTemp,
          userImg: authState.userImg,
          firstName: authState.firstname,
          lastName: authState.lastname,
          chatId,
        }
        if (otherUserEmail)
          await createNotifications(token, authState.firstname, [otherUserEmail], data)
      }
    }
    setMessageTemp('')
  }

  useEffect(() => {
    return () => {
      if (typingTimer) {
        clearTimeout(typingTimer)
      }
    }
  }, [typingTimer])

  return (
    <div className='chat__footer'>
      <div className='chat__footer_form'>
        <div>
          <input
            type='text'
            placeholder='Votre message ...'
            className='message mb-5'
            value={messageTemp}
            onChange={(e) => setMessageTemp(e.target.value)}
            onFocus={() => showEmojiPicker && setShowEmojiPicker(false)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSendMessage()
              } else {
                handleTyping()
              }
            }}
          />
          {/* <button className='emojiBtn' onClick={handleToggleEmojiPicker}>
            😃
          </button> */}
          {/* {showEmojiPicker && <EmojiPicker onEmojiClick={handleEmojiSelect} />} */}
          {/* <Send onClick={handleFileButtonClick} /> */}
          {/* <input
            type='file'
            accept='image/*'
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={(e) => handleFileUpload(e.target.files)}
          /> */}
        </div>
        <button
          className='sendBtn'
          onClick={() => {
            showEmojiPicker && setShowEmojiPicker(false)
            handleSendMessage()
          }}
        >
          Envoyer
        </button>
      </div>
    </div>
  )
}

export default ChatFooter
